import React, { useCallback } from 'react';
import { firebase, useCustomRouter } from '@vette/frontend-utils';
import * as S from '../AcceptSessionModal/styles';

export const VetterDisabledModal: React.FC<{ visible: boolean }> = ({
  visible,
}) => {
  const { router } = useCustomRouter();
  const { logout } = firebase.useFirebase();

  const onConfirm = useCallback(async () => {
    await logout();
    router.replace('/login');
  }, [router]);

  return (
    <S.Modal
      visible={visible}
      centered
      closable={false}
      destroyOnClose={true}
      width={700}
      footer={[
        <S.AcceptButton size="large" key="acceptButton" onClick={onConfirm}>
          Ok
        </S.AcceptButton>,
      ]}
      title="Ooops!"
    >
      <p>
        Your account has been disabled. Contact us at info@vette.io for help.
      </p>
    </S.Modal>
  );
};
